module.exports = __webpack_public_path__ + "assets/b58400ceea32f65887182e54e91c282e.gif";